export enum AGENT_HUB_COMPLIANCE {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=783896014
     */
    INSTRUCTIONS_DESCRIPTION = 'AGENT_HUB_COMPLIANCE.INSTRUCTIONS_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=785794345
     */
    INSTRUCTIONS_PLACEHOLDER = 'AGENT_HUB_COMPLIANCE.INSTRUCTIONS_PLACEHOLDER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=785794200
     */
    TEXT_AUTOMATICALLY_ADDED_TO_EVERY_AGENT = 'AGENT_HUB_COMPLIANCE.TEXT_AUTOMATICALLY_ADDED_TO_EVERY_AGENT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=783896323
     */
    WRITE_CLEAR_RULES = 'AGENT_HUB_COMPLIANCE.WRITE_CLEAR_RULES',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=832842607
     */
    GLOBAL_AGENT_GUIDELINES = 'AGENT_HUB_COMPLIANCE.GLOBAL_AGENT_GUIDELINES',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=822578612
     */
    GUIDELINES_AND_GUARDRAILS_FOR_AGENTS = 'AGENT_HUB_COMPLIANCE.GUIDELINES_AND_GUARDRAILS_FOR_AGENTS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=822578619
     */
    SET_OVERARCHING_DIRECTIVES_TO_ENFORCE_GUARDRAILS = 'AGENT_HUB_COMPLIANCE.SET_OVERARCHING_DIRECTIVES_TO_ENFORCE_GUARDRAILS',
}
